import React from 'react';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material';
import FormSubmissionSuccessDialog from '../FormSubmissionSuccessDialog/FormSubmissionSuccessDialog';
import './ReuploadApiResponseDialog.scss';

const ReuploadApiResponseDialog = ({
    open,
    type = 'success',
    message,
    applicationId,
    documentRemarks = [],
    onClose,
    successTitle = 'Documents Re-Uploaded',
    successEyebrow = 'Documents updated',
    errorTitle = 'Request Failed',
}) => {
    if (type === 'success') {
        return (
            <FormSubmissionSuccessDialog
                open={open}
                onClose={onClose}
                eyebrow={successEyebrow}
                title={successTitle}
                message={message || 'Documents re-uploaded successfully.'}
                trackingId={applicationId}
                trackingLabel="Application Id"
            >
                {documentRemarks.length > 0 ? (
                    <div className="reupload-api-remarks">
                        <p className="reupload-api-remarks__heading">Document Remarks</p>
                        <div className="reupload-api-remarks__list">
                            {documentRemarks.map(({ label, remarks }, index) => (
                                <div key={`${label}-${index}`} className="reupload-api-remarks__item">
                                    <p className="reupload-api-remarks__label">{label}</p>
                                    <p className="reupload-api-remarks__text">{remarks}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                ) : null}
            </FormSubmissionSuccessDialog>
        );
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            className="dde-result-dialog dde-result-dialog--reject"
            fullWidth
            maxWidth="sm"
            PaperProps={{ className: 'dde-result-dialog__paper' }}
        >
            <DialogTitle className="dde-result-dialog__title">
                <Box className="dde-result-dialog__icon-wrap">
                    <HighlightOffIcon className="dde-result-dialog__icon dde-result-dialog__icon--reject" />
                </Box>
                <Typography variant="h6" className="dde-result-dialog__heading">
                    {errorTitle}
                </Typography>
            </DialogTitle>
            <DialogContent className="dde-result-dialog__content">
                <p className="dde-result-dialog__message">
                    {message || 'Failed to re-upload documents. Please try again.'}
                </p>
            </DialogContent>
        </Dialog>
    );
};

export default ReuploadApiResponseDialog;
